import { c as _c } from "react/compiler-runtime";
import { Fragment } from 'react';
import { getENV, type SitePreviewData } from '@libs/common-next';
import { getItems } from './config';
import css from './configuration.module.scss';
import { DatePicker } from './date-picker';
import { EnvironmentSelect } from './environment-select';
import { Switch } from './switch';
import { splitWarning } from './utils';
interface Props {
  state: SitePreviewData;
  onChange: (key: keyof SitePreviewData, value: SitePreviewData[keyof SitePreviewData]) => void;
}
export function Configuration(t0) {
  const $ = _c(7);
  const {
    state,
    onChange
  } = t0;
  let t1;
  let t2;
  if ($[0] !== onChange || $[1] !== state) {
    const items = getItems(getENV("NEXT_PUBLIC_APP_ENV"));
    t1 = css.list;
    t2 = items.map(item => {
      const [mainDesc, warning] = splitWarning(item.description);
      return <Fragment key={item.key}><div className={css.row}><div className={css.label}><span className={css.name}>{item.title}</span><span className={css.description}>{mainDesc}</span>{warning && <span className={css.warning}>{warning}</span>}</div>{item.type === "select" ? <EnvironmentSelect name={item.key} value={state[item.key]} options={item.options} onChange={onChange} /> : item.type === "switch" ? <Switch name={item.key} value={state[item.key]} onChange={onChange} /> : <DatePicker name={item.key} value={state[item.key]} onChange={onChange} />}</div><div className={css.divider} /></Fragment>;
    });
    $[0] = onChange;
    $[1] = state;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}